import { render, staticRenderFns } from "./myicon.vue?vue&type=template&id=1eb19d12"
import script from "./myicon.vue?vue&type=script&lang=js"
export * from "./myicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports